import { GET_INVOICE_TXNS_SUCCESS } from './invoiceTxn.type';

const initialState = {
    invoiceTxns: [],
    invoiceTxnCount: 0,
};

export const invoiceTxnReducer = (state = initialState, action) => {
    switch (action.type) {
        case GET_INVOICE_TXNS_SUCCESS:
            return {
                ...state,
                invoiceTxns: action.payload?.txns || [],
                invoiceTxnCount: action.payload?.count || 0,
            };
        default:
            return state;
    }
};
